import { createStore } from 'vuex'

import buildComms from '@app/application/communication/sections/communication/store/comms'

import users from '@app/application/communication/sections/communication/store/users'
import contexts from '@app/application/communication/sections/communication/store/contexts'
import checks from '@app/application/communication/sections/communication/store/checks'
import attachments from '@app/application/communication/sections/communication/store/attachments'
import comments from '@app/application/communication/sections/communication/store/comments'
import ui from '@app/application/communication/sections/communication/store/ui'
import remarks from '@app/application/communication/sections/communication/store/remarks'
import remarkTags from '@app/application/communication/sections/communication/store/remark-tags'

import sections from './sections'
import notifications from './notifications'
import * as mutationTypes from './mutation-types'

export default function createFirmInboxStore(
  endpointParams,
  fetchCommunicationFn
) {
  const { state, getters, mutations, actions } = buildComms(
    endpointParams,
    {},
    fetchCommunicationFn
  )

  return createStore({
    modules: {
      users,
      contexts,
      checks,
      attachments,
      comments: comments,
      notifications,
      ui,
      remarks,
      remarkTags,
      sections,
    },
    state() {
      return {
        ...state(),
        loading: {
          notifications: false,
          companies: false,
          mentionUsernames: false,
          communicationItem: false,
        },
      }
    },
    getters: {
      ...getters,
      loadingNotifications: ({ loading }) => loading.notifications,
      loadingCompanies: ({ loading }) => loading.companies,
    },
    mutations: {
      ...mutations,
      [mutationTypes.SET_LOADING](state, { type, value }) {
        state.loading[type] = value
      },
    },
    actions,
  })
}
